module.exports = __webpack_public_path__ + "static/media/line-chart-icon.0f21e80a.svg";